import { InputNumber as AntInputNumber } from 'antd';
import React, { FC } from 'react';
import {
  FieldOption,
  FieldValueType,
  FieldWithValue,
  StatusGroup,
} from 'api/tasks';
import { useNumericInput } from 'hooks/use-input';
import { logger } from 'services';

export interface NumberField extends Omit<FieldWithValue, 'metaData'> {
  metaData?: {
    default?: FieldValueType;
    options: Array<FieldOption<number | StatusGroup>>;
    range?: {
      min: number;
      max: number;
    };
    rangeAvailable: boolean;
  };
}

interface Props {
  field: NumberField;
  initialValue?: number;
  onPressEnter?: () => void;
  onBlur?: () => void;
  onChange: (newValue, field) => void;
}

export const InputNumberField: FC<Props> = (props) => {
  const { initialValue = Number(''), onChange, field } = props;
  const [value, onInputChange, setValue] = useNumericInput(initialValue);
  const handleOnEnter = (e) => {
    e.currentTarget?.blur();
  };
  const save = async (e: React.ChangeEvent<HTMLInputElement>) => {
    try {
      onChange(Number(e.target.value), field);
    } catch (error) {
      logger.error('Save failed:', { error });
    }
  };

  return (
    <AntInputNumber
      min={field.metaData?.range?.min}
      max={field.metaData?.range?.max}
      size="small"
      placeholder="—"
      value={value}
      onInput={onInputChange}
      defaultValue={field.metaData?.default as number}
      onChange={(v) => setValue(v)}
      onPressEnter={handleOnEnter}
      onBlur={save}
    />
  );
};
